// extracted by mini-css-extract-plugin
export default {"modalHeader":"WarningModal_modalHeader__TSAYp","modalTitle":"WarningModal_modalTitle__-pNYX","modalBody":"WarningModal_modalBody__RJSyl","button":"WarningModal_button__whjpR"};